module.exports = __webpack_public_path__ + "static/media/bg-1.e0cf79f.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/zh/pc/vedio/bg-1.webm
// module id = CtQd
// module chunks = 13